import React from 'react';
import { faqData, siteConfig } from '../../data/mock';
import { MessageCircle, ArrowRight } from 'lucide-react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const FaqSection = () => {
  const whatsappLink = `https://wa.me/${siteConfig.whatsappNumber}?text=${encodeURIComponent(siteConfig.whatsappMessage)}`;

  return (
    <section className="py-24 bg-neutral-50">
      <div className="max-w-3xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-serif text-neutral-900 mb-4">
            Perguntas frequentes
          </h2>
        </div>
        
        {/* Accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {faqData.map((item, index) => (
            <AccordionItem 
              key={index} 
              value={`item-${index}`}
              className="bg-white border border-neutral-200 rounded-xl px-6 overflow-hidden data-[state=open]:shadow-lg data-[state=open]:border-[#c9a962]/50 transition-all duration-300"
            >
              <AccordionTrigger className="text-left text-lg font-semibold text-neutral-900 hover:text-[#c9a962] hover:no-underline py-6 [&[data-state=open]]:text-[#c9a962]">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="text-neutral-600 leading-relaxed pb-6">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
        
        {/* CTA */}
        <div className="text-center mt-12">
          <p className="text-neutral-600 mb-6 text-lg">
            Tire sua dúvida agora.
          </p>
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center justify-center gap-3 bg-emerald-600 hover:bg-emerald-500 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-emerald-500/25"
          >
            <MessageCircle className="w-5 h-5" />
            {siteConfig.ctaText}
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
